import React from 'react';
import useModuleData from '@wix/da-gruser-shared/pkg/hooks/useModuleData';
import { PapiModuleExhibitionist } from '@wix/da-papi-types';
import DeviationTorpedo from '../../../Torpedo/DeviationTorpedo';
import { MeasuredCookieType } from '@wix/da-hooks/pkg/useMeasureElement/redux/types';

interface Props {
  moduleId: number;
}

const container = { width: 450, maxRows: 3 };
const defaultSize = {
  desktop: { width: 450, height: 0 },
  mobile: { width: 375, height: 0 },
};

const ExhibitionistGrid: React.FC<Props> = ({ moduleId }) => {
  const { moduleData } = useModuleData<PapiModuleExhibitionist>(moduleId);
  const { deviations } = moduleData;

  return (
    <DeviationTorpedo
      items={deviations}
      container={container}
      cookieType={MeasuredCookieType.USER_PROFILE_FEATURED}
      cookieDim={'width'}
      defaultSize={defaultSize}
      hideIncompleteRows
      enableScrollVisibilityOptimisation
    />
  );
};
ExhibitionistGrid.displayName = 'ExhibitionistGrid';

export default ExhibitionistGrid;
